import Axios from 'axios'

export const createSellerReplacement = async (params) => {
  const response = await Axios.post('/sellerReplacements/createReplacement', params)
  return response.data
}

export const updateSellerReplacement = async (params) => {
  const response = await Axios.post('/sellerReplacements/updateReplacement', params)
  return response.data
}

export const searchSellerReplacements = async (searchParams) => {
  const response = await Axios.post('/sellerReplacements/search', searchParams)
  return response.data
}

export const getActiveReplacementForTelemarketer = async (telemarketerId) => {
  const response = await Axios.get(
    `/sellerReplacements/getActiveReplacementForTelemarketer?telemarketerId=${telemarketerId}`,
  )
  return response.data
}
